<template>
  <ion-grid>
    <div id="clock">
      <p class="date">{{ dtData.date }}</p>
      <p class="time">{{ dtData.time }}</p>
      <p class="text">
        chronos by
        <a href="https://www.nigelvm.com" target="_blank" rel="noreferrer"
          >nigelvm</a
        >
      </p>
    </div>
  </ion-grid>
</template>

<script>
export default {
  name: "chronos",
  data() {
    return {
      dtData: {
        date: this.getDateTimeNow()[0],
        time: this.getDateTimeNow()[1]
      },
      timer: ""
    };
  },
  created() {
    this.timer = setInterval(
      function(dtFunc, dtdat) {
        dtdat.date = dtFunc()[0];
        dtdat.time = dtFunc()[1];
      },
      1000,
      this.getDateTimeNow,
      this.dtData
    );
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getDateTimeNow() {
      var cd = new Date();
      var week = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
      var ntime =
        this.zeroPadding(cd.getHours(), 2) +
        ":" +
        this.zeroPadding(cd.getMinutes(), 2) +
        ":" +
        this.zeroPadding(cd.getSeconds(), 2);
      var ndate =
        week[cd.getDay()] +
        " " +
        this.zeroPadding(cd.getDate(), 2) +
        "-" +
        this.zeroPadding(cd.getMonth() + 1, 2) +
        "-" +
        this.zeroPadding(cd.getFullYear(), 4);

      return [ndate, ntime];
    },
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }

      return (zero + num).slice(-digit);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
html,
body {
  height: 100%;
  overflow: hidden;
}
body {
  background: #0f3854;
  background: radial-gradient(ellipse at center, #0a2e38 0%, #000000 70%);
  background-size: 100%;
}
p {
  margin: 0;
  padding: 0;
}
#clock {
  font-family: "Share Tech Mono", monospace;
  color: #ffffff;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #daf6ff;
  text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0);
  width: 92%;
  padding-left: 4px;
  padding-right: 4px;
}
#clock a {
  color: #daf6ff;
  text-decoration: none;
}
#clock .time {
  letter-spacing: 0.05em;
  font-size: 64px;
  padding: 5px 0;
}
#clock .date {
  letter-spacing: 0.1em;
  font-size: 24px;
}
#clock .text {
  letter-spacing: 0.1em;
  font-size: 12px;
  padding: 20px 0 0;
}
</style>
